// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"189":"c5f801c8","238":"85a6321e","486":"60f916c0","945":"1ee3772a"}[chunkId] + ".css";
};